module.exports = __webpack_public_path__ + "static/media/backArrow.734920cf.svg";